<template>
  <el-form
      ref="form"
      @submit.native.prevent
      :model="form">
    <el-row
        type="flex"
        class="gj-picker">
      <div class="gj-picker__editor">
        <el-tabs :value="'first'">
          <el-tab-pane
              label="排除品牌"
              name="first"
              >
            <div class="gj-picker__editor--search-input">
              <gj-input
                  v-model="keyword"
                  placeholder="搜索品牌"
                  size="medium"
                  underline
                  isEnter
                  :enterConfig="{componentName: 'app-neg-target-picker', eventName: 'searchBrand'}"
                  width="100%"
                  class="search-brand">
                <template #append>
                  <gj-button
                      icon="el-icon-search"
                      size="medium"
                      @click="searchBrand"></gj-button>
                </template>
              </gj-input>
            </div>
            <div class="gj-picker__editor--body">
              <gj-table
                  :index="false"
                  :show-pagination="false"
                  :adapt-height="false"
                  :height="324"
                  :loading="brandLoading"
                  :data="tableData"
                  :columns="columns0"
                  stripe>
                <template v-slot:header:op>
                  <gj-button
                      type="text"
                      @click="addAllItem()"
                  >添加全部</gj-button>
                </template>
                <template v-slot:header:brand>
                  {{ brandHeaderName }}
                </template>
                <template v-slot:brand="{ row }">
                  {{ (row.asin || row.brandName) | defaultShow}}
                </template>
                <template v-slot:op="{ index, row }">
                  <gj-button
                      type="text"
                      :disabled="row.btnDisabled"
                      @click="addItem(index, row)"
                  >添加</gj-button>
                </template>
              </gj-table>
            </div>
          </el-tab-pane>
          <el-tab-pane label="排除ASIN" name="second">
            <div style="margin-top: 10px;padding: 0 12px">
              <div style="margin-bottom: 10px;">
                <gj-textarea
                    v-model="inputText"
                    :styles="{
                      height: '343px',
                      'border-color': this.errorKeyword ? '#F56C6C' : '',
                      fontSize: '12px'
                    }"
                    placeholder="请选择关键词，一行一个，回车换行">
                </gj-textarea>
              </div>
              <el-row
                  type="flex"
                  align="middle"
                  justify="space-between"
                  class="gj-picker__editor--footer">
                <span :class="{red: errorKeyword}">关键词不得包含特殊字符，如@、#、*和$等</span>
                <!---->
                <gj-button
                    type="primary"
                    @click="addByInput"
                    :disabled="!isMeaningful(inputText)"
                >添加</gj-button>
              </el-row>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="gj-picker__table">
        <div class="gj-picker__table--title">
          已添加 {{form.items.length}} 个{{title}}<span class="gj-picker__table--tip">（最多可添加1000个，会过滤重复的{{title}}）</span>
        </div>
        <gj-table
            :index="false"
            :show-pagination="false"
            :adapt-height="false"
            :height="403"
            stripe
            :data="form.items"
            :columns="columns">
          <template v-slot:header:op>
            <gj-button
                type="text"
                @click="deleteAllItem()"
            >全部移除</gj-button>
          </template>
          <template v-slot:negativedProduct="{ row }">
            <template v-if="isMeaningful(row.asin)">商品： {{row.asin}}</template>
            <template v-else-if="isMeaningful(row.brandName)">品牌： {{row.brandName}}</template>
            <template v-else>-</template>
          </template>
          <template v-slot:op="{ index, row }">
            <gj-button
                type="text"
                @click="deleteItem(index, row)"
            >移除</gj-button>
          </template>
        </gj-table>
      </div>
    </el-row>
    <div class="gj-picker-solid"></div>
  </el-form>
</template>

<script>
  import {formMixin, isMeaningfulMixin} from "../../../../../../../../minxins";
  import {isMeaningful, isMeaningless, meaningfulEq, unique} from "../../../../../../../../utils/common";
  import {adStoreMixin} from "../../../../../common/mixin";
  import {getProductBrands, getAdProductTargetBrand} from "../../../../../../../../api/ad";

  export default {
    name: "app-neg-target-picker",
    mixins: [isMeaningfulMixin, formMixin, adStoreMixin],
    props: {
      title: {
        required: true,
      },
      marketId: {
        required: true
      }
    },
    created() {
      this.getMarketBrand();
    },
    data() {
      return {
        tableData: [],
        marketBrandData: [],
        brandHeaderName: '您的品牌',
        keyword: null,
        inputText: null,
        columns0: [
          {id: 'brand', header: 'slot:brand', field: 'slot:brand', minWidth: '180px'},
          {id: 'op', header: 'slot:op', field: 'slot:op', width: '80px'},
        ],
        columns: [
          {id: 'negativedProduct', header: '否定目标', field: 'slot:negativedProduct', minWidth: '180px'},
          {id: 'op', header: 'slot:op', field: 'slot:op', width: '80px'},
        ],
        errorKeyword: false,
        keywordStyle: {height: '292px'},
        brandLoading: false
      }
    },
    watch: {
      inputText(val) {
        this.errorKeyword = !/^[^!#%<>@*$]*$/.test(val);
      },
      keyword(val) {
        if (isMeaningless(val)) {
          this.tableData = this.marketBrandData;
          this.brandHeaderName = '您的品牌';
          this.refreshBtnDisable();
        }
      }
    },
    methods: {
      getMarketBrand() {
        this.brandLoading = true;
        getProductBrands({marketId: this.marketId})
          .then((data) => {
            this.marketBrandData = this.tableData = (data || []).map(e => ({
              id: e.id,
              brandId: e.brandId,
              brandName: e.brandRegistryName
            }));
          })
          .complete(() => this.brandLoading = false);
      },
      searchBrand() {
        if (isMeaningless(this.keyword)) {
          this.$gjMessage.warning('请输入品牌名后搜索');
          return;
        }
        this.brandLoading = true;
        getAdProductTargetBrand({
          marketId: this.marketId,
          keyword: this.keyword
        })
          .then((data) => {
            this.tableData = (data || []).map(e => ({
              id: e.id,
              brandId: e.id,
              brandName: e.name
            }));
            this.brandHeaderName = '排除品牌';
            this.refreshBtnDisable();
          })
          .complete(() => this.brandLoading = false)
      },
      addAllItem() {
        this.form.items = unique([].concat(this.form.items).concat(this.tableData));
        this.refreshBtnDisable();
      },
      addItem(index, row) {
        this.form.items = unique([].concat(this.form.items).concat([row]));
        this.refreshBtnDisable();
      },
      refreshBtnDisable() {
        this.tableData.forEach(e1 => {
          if (this.form.items.some(e2 => meaningfulEq(e1.id, e2.id))) {
            this.$set(e1, 'btnDisabled', true);
          } else {
            this.$set(e1, 'btnDisabled', false);
          }
        });
      },
      deleteAllItem() {
        this.form.items = [];
        this.refreshBtnDisable();
      },
      deleteItem(index) {
        this.form.items.splice(index, 1);
        this.refreshBtnDisable();
      },
      addByInput() {
        const items = [];
        this.inputText.split('\n')
          .map(item => item.replace(/^(\s|\n)+|(\s|\n)+?$/, ''))
          .filter(item => isMeaningful(item) && !/\n+/.test(item))
          .forEach(item => {
            items.push({
              id: item,
              asin: item
            });
          });
        this.form.items = unique([].concat(this.form.items).concat(items));
        this.inputText = null;
      },
      formValidate() {
        let formValid = this.form.items.length > 0;
        if (!formValid) {
          this.$gjMessage.error('请添加否定商品');
          return false;
        }
        this.$refs.form.validate((valid) => {
          formValid = formValid && valid;
        });
        return formValid;
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "picker";
  
  .gj-picker__editor {
    padding: 0;
  }
  .gj-picker {
    height: 445px !important;
    overflow: hidden;
  }
  
  .gj-picker__editor,
  .gj-picker__table {
    width: 50%;
    height: 443px !important;
  }
  
  .default-bid {
    margin-bottom: 0;
    position: absolute;
    top: 0;
    left: 280px;
  }
  
  /deep/ .el-tabs__header {
    margin-bottom: 0 !important;
  }
  
  /deep/ .gj-picker__editor--search-input .el-input__inner {
    height: 39px;
    line-height: 39px;
    font-size: 13px;
  }

  /deep/ .gj-picker__editor--search-input .el-input-group__append {
    border-radius: 0;
    border-right: 0;
    font-size: 14px;
  }
  /deep/.gj-underline-input {
    margin-top: 1px !important;
  }
  .search-brand {
    /deep/.el-input__inner {
      border: 0;
      border-bottom: 1px solid #d9d9d9;
    }
  }
</style>

